import { CmsMarketingPreferencesPage } from '../../models/cms/cms-marketing-preferences-page.interface';
import { mockCmsMarketingPreferencesForm } from './cms-marketing-preferences-form.mock';

export const mockCmsMarketingPreferencesPage: CmsMarketingPreferencesPage = {
  ...mockCmsMarketingPreferencesForm,
  pageTitle: 'Just a few more details',
  pageSubtitle:
    'We would love to send you updates with the latest news and offers from time to time, always in line with the privacy policy',
};
